<script setup lang="ts">
import { computed } from 'vue'

import type { AdditionalHeaders } from '../../paragraph-types/ParagraphTypeEpgDetailHeader.vue'

type Badges = AdditionalHeaders['badges']

const props = withDefaults(defineProps<{
  badges?: Badges
  inlineUsage?: boolean
}>(), {
  inlineUsage: false
})

const badgeText: Record<keyof NonNullable<Badges>, string> = {
  isPopular: 'beliebt',
  isNew: 'neu',
  isTip: 'Tipp',
  isDailyTip: 'Tagestipp',
  isTopTip: 'Top-Tipp',
  isLive: 'Live',
  isHD: 'HD',
  is16to9: '16:9',
  isDolbyDigital: 'DD',
  isLastBroadcast: 'Letzte Ausstrahlung',
  isYouthProtected: 'Jugendschutz'
}

const badgeList = computed(() => {
  const badges = props.badges ?? {}
  return (Object.keys(badges) as Array<keyof NonNullable<Badges>>)
    .filter(key => badges[key]) // only keys with truthy values
    .map(key => {
      const lowercaseKey = key.replace(/^is/, '').toLowerCase() // remove "is" and make lowercase
      return badgeText[key] || lowercaseKey // final text or lowercase key as name to show
    })
})
</script>

<template>
  <div v-if="badgeList.length"
       class="bx-content__badges bx-typo--content-badges"
       :class="{ 'bx-content': !inlineUsage }">
    <span v-for="badge in badgeList"
          :key="badge"
          :data-badge="badge.toLowerCase()">
      {{ badge }}
    </span>
  </div>
</template>
